import {Injectable, inject} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import { Global } from './core/Global';


@Injectable()

export class RequestInsuredService {
	private url: string = Global.url_seguros
	private _http = inject(HttpClient)


	incorporation(params: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.post(this.url + 'request/incorporation', params, {headers: headers})
	}
	exclution(params: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.patch(this.url + 'request/exclution/', params, {headers: headers})
	}
	transfer(params: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.patch(this.url + 'request/transfer/', params, {headers: headers})
	}
	update(params: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.patch(this.url + 'request/update/', params, {headers: headers})
	}
	getTypeMovement(): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.get(this.url + 'types-movements', {headers: headers})
	}

	updateTypeMovement(type: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.patch(this.url + 'types-movements', type, {headers: headers})
	}

	createTypeMovement(type: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.post(this.url + 'types-movements', type, {headers: headers})
	}

	getRequests(params: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.get(this.url + 'request/get' , {headers: headers, params: params})
	}
	getRequest(params: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.get(this.url + 'request/get/' + params, {headers: headers})
	}

	statusRequest(params: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.post(this.url + 'request/approval-workflow', params, {headers: headers})
	}

	cancelRequest(params: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.post(this.url + 'request/cancel', params, {headers: headers})
	}

	getDashboard(date: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.get(this.url + 'request/dashboard', {headers: headers, params: {date}})
	}

	getDashboardData(period: string, entityId?: string): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		const params: any = {period}
		if (entityId) params.entityId = entityId
		return this._http.get(this.url + 'dashboard/data', {headers: headers, params})
	}

	getInsuredSummary(period: string, entityId?: string, coverageId?: string): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		const params: any = {period}
		if (entityId) params.entityId = entityId
		if (coverageId) params.coverageId = coverageId
		return this._http.get(this.url + 'dashboard/insured-summary', {headers: headers, params})
	}

	notification(params: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.post(this.url + 'request/notification', params, {headers: headers})
	}

	notificationMovement(params: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.post(this.url + 'request/notification-movement', params, {headers: headers})
	}

}
